import React from 'react'

import { List } from '@chakra-ui/react'
import VirtualList from 'react-tiny-virtual-list'
// import { List as VirtualList } from 'react-virtualized'

const DefaultItemHeight = 40

const CustomMenuList = ({ options, children, maxHeight, getValue }) => {
  const [value] = getValue()
  const initialOffset = options.indexOf(value) * DefaultItemHeight
  const childrenOptions = React.Children.toArray(children)
  const wrapperHeight =
    maxHeight < childrenOptions.length * DefaultItemHeight ? maxHeight : childrenOptions.length * DefaultItemHeight

  const renderItem = (props) => {
    if (Array.isArray(children)) {
      return (
        <li style={props.style} key={props.index}>
          {children[props.index]}
        </li>
      )
    }
    return <li key={props.index}>{children.props.children}</li>
  }

  return (
    <List>
      <VirtualList
        width="100%"
        height={wrapperHeight + 10}
        scrollOffset={initialOffset}
        itemCount={childrenOptions.length}
        itemSize={DefaultItemHeight}
        renderItem={renderItem}
      />
    </List>
  )
}

export default CustomMenuList
